import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h2>My History</h2>
        </div>
    );
};

export default MyHistory;